module.exports = __webpack_public_path__ + "static/media/weightscale.bbd6a16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weightscale.png
// module id = 754
// module chunks = 0